<template>
  <div class="xindian-station">
    <pageTable 
      ref="table"
      :tableTitle="tableColumn"
      :searchData="searchData"
      tableApi="admin/xindian_station/getStationLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="id">
          <Input type="text" v-model="searchData.id" placeholder="ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="station_id">
          <Input type="text" v-model="searchData.station_id" placeholder="站点ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="station_name">
          <Input type="text" v-model="searchData.station_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="operator_id">
          <Input type="text" v-model="searchData.operator_id" placeholder="运营商ID" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="station_status">
          <Select v-model="searchData.station_status" placeholder="站点状态" clearable>
            <Option value="0">未知</Option>
            <Option value="1">建设中</Option>
            <Option value="5">关闭下线</Option>
            <Option value="6">维护中</Option>
            <Option value="50">正常使用</Option>
          </Select>
        </FormItem>
        <FormItem prop="station_type">
          <Select v-model="searchData.station_type" placeholder="站点类型" clearable>
            <Option value="1">公共</Option>
            <Option value="50">个人</Option>
            <Option value="100">公交（专用）</Option>
            <Option value="101">环卫（专用）</Option>
            <Option value="102">物流（专用）</Option>
            <Option value="103">出租车（专用）</Option>
            <Option value="255">其他</Option>
          </Select>
        </FormItem>
        <FormItem prop="construction">
          <Select v-model="searchData.construction" placeholder="建设场所" clearable>
            <Option value="1">居民区</Option>
            <Option value="2">公共机构</Option>
            <Option value="3">企事业单位</Option>
            <Option value="4">写字楼</Option>
            <Option value="5">工业园区</Option>
            <Option value="6">交通枢纽</Option>
            <Option value="7">大型文体设施</Option>
            <Option value="8">城市绿化</Option>
            <Option value="9">大型建筑配建停车场</Option>
            <Option value="10">路边停车位</Option>
            <Option value="11">城际高速服务区</Option>
            <Option value="255">其他</Option>
          </Select>
        </FormItem>
        <FormItem prop="status">
          <Select v-model="searchData.status" placeholder="系统状态" clearable>
            <Option value="0">下线</Option>
            <Option value="1">在线</Option>
          </Select>
        </FormItem>
        <FormItem prop="park_tag">
          <Select v-model="searchData.park_tag" placeholder="停车标签" clearable>
            <Option value="1">免费停车</Option>
            <Option value="2">限时免费停车</Option>
            <Option value="3">停车收费</Option>
          </Select>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker 
            v-model="searchData.create_time" 
            type="datetimerange" 
            @on-change="timeChange" 
            placeholder="创建时间" 
            style="width: 320px"
          ></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
<!--        <FormItem>-->
<!--          <Button type="warning" @click="syncStations">同步站点</Button>-->
<!--        </FormItem>-->
      </template>
    </pageTable>

    <!-- 站点详情抽屉 -->
    <Drawer 
      title="站点详情" 
      width="900"
      :value="detailDrawer.show"
      :mask-closable="true" 
      @on-close="closeDetailDrawer"
    >
      <div v-if="detailDrawer.data" class="station-detail">
        <div class="detail-section">
          <h3>基本信息</h3>
          <Row>
            <Col span="12">
              <p><strong>站点ID:</strong> {{ detailDrawer.data.station_id }}</p>
              <p><strong>站点名称:</strong> {{ detailDrawer.data.station_name }}</p>
              <p><strong>运营商:</strong> {{ detailDrawer.data.operator_name }}</p>
              <p><strong>联系电话:</strong> {{ detailDrawer.data.station_tel || detailDrawer.data.service_tel }}</p>
            </Col>
            <Col span="12">
              <p><strong>站点状态:</strong> {{ getStationStatusText(detailDrawer.data.station_status) }}</p>
              <p><strong>系统状态:</strong> {{ getSystemStatusText(detailDrawer.data.status)}}</p>
              <p><strong>站点类型:</strong> {{ getStationTypeText(detailDrawer.data.station_type) }}</p>
              <p><strong>建设场所:</strong> {{ getConstructionText(detailDrawer.data.construction) }}</p>
            </Col>
          </Row>
        </div>

        <div class="detail-section">
          <h3>位置信息</h3>
          <p><strong>地址:</strong> {{ detailDrawer.data.address }}</p>
          <p><strong>经纬度:</strong> {{ detailDrawer.data.station_lat }}, {{ detailDrawer.data.station_lng }}</p>
          <p><strong>区域编码:</strong> {{ detailDrawer.data.area_code }}</p>
        </div>

        <div class="detail-section">
          <h3>运营信息</h3>
          <Row>
            <Col span="12">
              <p><strong>营业时间:</strong> {{ detailDrawer.data.busine_hours || '24小时' }}</p>
              <p><strong>停车位数量:</strong> {{ detailDrawer.data.park_nums }}</p>
              <p><strong>停车标签:</strong> {{ getParkTagText(detailDrawer.data.park_tag) }}</p>
            </Col>
            <Col span="12">
              <p><strong>是否支持预约:</strong> {{ detailDrawer.data.support_order ? (detailDrawer.data.support_order == 1 || detailDrawer.data.support_order == true ? '支持' : '不支持') : '不支持' }}</p>
              <p><strong>VIN支持:</strong> {{ detailDrawer.data.vin_flag ? (detailDrawer.data.vin_flag == 1 || detailDrawer.data.vin_flag == true ? '支持' : '不支持') : '不支持' }}</p>
              <p><strong>HW超级充电:</strong> {{ detailDrawer.data.hw_supper_charge ? (detailDrawer.data.hw_supper_charge == 1 || detailDrawer.data.hw_supper_charge == true ? '是' : '否') : '否' }}</p>
            </Col>
          </Row>
        </div>

        <div class="detail-section" v-if="detailDrawer.data.electricity_fee || detailDrawer.data.service_fee">
          <h3>费用信息</h3>
          <p v-if="detailDrawer.data.electricity_fee"><strong>电费:</strong> {{ detailDrawer.data.electricity_fee }}</p>
          <p v-if="detailDrawer.data.service_fee"><strong>服务费:</strong> {{ detailDrawer.data.service_fee }}</p>
          <p v-if="detailDrawer.data.park_fee"><strong>停车费:</strong> {{ detailDrawer.data.park_fee }}</p>
        </div>
      </div>
    </Drawer>

    <!-- 编辑站点模态框 -->
    <Drawer
        title="编辑站点"
        width="900"
        :value="editDrawer.show"
        :mask-closable="true"
        @on-close="closeEditDrawer"
    >
      <div v-if="editDrawer.data" class="station-edit">
        <Form
            ref="editForm"
            :model="editDrawer.form"
            :label-width="120"
            :rules="editDrawer.rules"
        >
          <div class="detail-section">
            <h3>基本信息</h3>
            <Row>
              <Col span="12">
                <FormItem label="站点ID">
                  <Input v-model="editDrawer.data.station_id" disabled></Input>
                </FormItem>
                <FormItem label="站点名称" prop="station_name">
                  <Input v-model="editDrawer.form.station_name" placeholder="请输入站点名称"></Input>
                </FormItem>
                <FormItem label="运营商">
                  <Input v-model="editDrawer.data.operator_name" disabled></Input>
                </FormItem>
                <FormItem label="联系电话" prop="station_tel">
                  <Input v-model="editDrawer.form.station_tel" placeholder="请输入联系电话"></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="站点状态" prop="station_status">
                  <Select v-model="editDrawer.form.station_status">
                    <Option value="0">未知</Option>
                    <Option value="1">建设中</Option>
                    <Option value="5">关闭下线</Option>
                    <Option value="6">维护中</Option>
                    <Option value="50">正常使用</Option>
                  </Select>
                </FormItem>
                <FormItem label="系统状态" prop="status">
                  <Select v-model="editDrawer.form.status">
                    <Option value="0">下线</Option>
                    <Option value="1">在线</Option>
                  </Select>
                </FormItem>
                <FormItem label="站点类型">
                  <Input :value="getStationTypeText(editDrawer.data.station_type)" disabled></Input>
                </FormItem>
                <FormItem label="建设场所">
                  <Input :value="getConstructionText(editDrawer.data.construction)" disabled></Input>
                </FormItem>
              </Col>
            </Row>
          </div>

          <div class="detail-section">
            <h3>位置信息</h3>
            <FormItem label="地址" prop="address">
              <Input
                  v-model="editDrawer.form.address"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入详细地址"
              ></Input>
            </FormItem>
            <Row>
              <Col span="12">
                <FormItem label="经度">
                  <Input v-model="editDrawer.data.station_lng" disabled></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="纬度">
                  <Input v-model="editDrawer.data.station_lat" disabled></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem label="省份">
                  <Input v-model="editDrawer.data.province" disabled></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="城市">
                  <Input v-model="editDrawer.data.city" disabled></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="区域编码">
                  <Input v-model="editDrawer.data.area_code" disabled></Input>
                </FormItem>
              </Col>
            </Row>
          </div>

          <div class="detail-section">
            <h3>运营信息</h3>
            <Row>
              <Col span="12">
                <FormItem label="营业时间">
                  <Input v-model="editDrawer.data.busine_hours" disabled></Input>
                </FormItem>
                <FormItem label="停车位数量">
                  <Input v-model="editDrawer.data.park_nums" disabled></Input>
                </FormItem>
                <FormItem label="停车标签" prop="park_tag">
                  <Select v-model="editDrawer.form.park_tag">
                    <Option value="1">免费停车</Option>
                    <Option value="2">限时免费停车</Option>
                    <Option value="3">停车收费</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="是否支持预约">
                <Input :value="editDrawer.form.support_order ? '是' : '否'" disabled></Input>
              </FormItem>
              <FormItem label="VIN支持">
                <Input :value="editDrawer.form.vin_flag ? '是' : '否'" disabled></Input>
              </FormItem>
              <FormItem label="HW超级充电">
                <Input :value="editDrawer.form.hw_supper_charge ? '是' : '否'" disabled></Input>
              </FormItem>
              </Col>
            </Row>
          </div>

          <div class="detail-section">
            <h3>费用信息</h3>
            <Row>
              <Col span="24">
                <FormItem label="电费">
                  <Input v-model="editDrawer.data.preferential_elec_fee" disabled></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="服务费">
                  <Input v-model="editDrawer.data.service_fee" disabled></Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem label="停车费">
                  <Input v-model="editDrawer.data.park_fee" disabled></Input>
                </FormItem>
              </Col>
            </Row>
          </div>

          <div class="edit-actions">
            <Button @click="closeEditDrawer" style="margin-right: 10px;">取消</Button>
            <Button type="primary" :loading="editDrawer.loading" @click="saveStation">保存</Button>
          </div>
        </Form>
      </div>
    </Drawer>

  </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";
import XLSX from "xlsx";
export default {
  name: 'XindianStation',
  components:{pageTable,XLSX},
  data() {
    return {
      searchData: {
        station_id: '',
        station_name: '',
        operator_id: '',
        area_code: '',
        station_status: '',
        station_type: '',
        construction: '',
        status: '',
        park_tag: '',
        create_time: []
      },
      editDrawer: {
        show: false,
        data: null,
        loading: false,
        form: {
          id: 0,
          station_name: '',
          station_status: '',
          status: '',
          park_tag: '',
          address: '',
          station_tel: '',
          support_order: false,
          vin_flag: false,
          hw_supper_charge: false
        },
        rules: {
          station_name: [{ required: true, message: '请输入站点名称', trigger: 'blur' }],
          station_status: [{ required: true, message: '请选择站点状态', trigger: 'change' }],
          address: [{ required: true, message: '请输入地址', trigger: 'blur' }]
        }
      },
      tableColumn: [
        { title: 'ID', key: 'id', minWidth: 120, align: 'center' },
        { title: '站点ID', key: 'station_id', minWidth: 120, align: 'center' },
        { title: '站点名称', key: 'station_name', minWidth: 150, align: 'left' },
        { title: '运营商ID', key: 'operator_id', minWidth: 120, align: 'center' },
        { title: '运营商', key: 'operator_name', minWidth: 120, align: 'center' },
        { title: '地址', key: 'address', minWidth: 200, align: 'left' },
        { title: '联系电话', key: 'station_tel', minWidth: 120, align: 'center' },
        { title: '服务电话', key: 'service_tel', minWidth: 120, align: 'center' },
        { title: '站点状态', minWidth: 100, align: 'center', render: (h, params) => {
            return h('span', this.getStationStatusText(params.row.station_status));
          }
        },
        { title: '系统状态', minWidth: 100, align: 'center', render: (h, params) => {
            const status = params.row.status;
            const color = status === 1 ? 'green' : 'red';
            const text = status === 1 ? '在线' : '下线';
            return h('Tag', { props: { color } }, text);
          }
        },
        { title: '停车标签', minWidth: 100, align: 'center', render: (h, params) => {
            return h('span', this.getParkTagText(params.row.park_tag));
          }
        },
        { title: '创建时间', key: 'create_time', minWidth: 160, align: 'center' },
        { title: '操作', fixed: 'right', width: 150, render: (h, params) => {
            return h('div', [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: { click: () => this.showDetail(params.row) }
              }, '详情'),
              h('Button', {
                props: { type: 'warning', size: 'small' },
                on: { click: () => this.editStation(params.row) }
              }, '编辑')
            ]);
          }
        }
      ],
      detailDrawer: {
        show: false,
        data: null
      },
      editModal: {
        show: false,
        title: '编辑站点',
        loading: false,
        form: {
          id: 0,
          station_name: '',
          station_status: '',
          status: 1,
          park_tag: 1,
          address: '',
          station_tel: ''
        },
        rules: {
          station_name: [{ required: true, message: '请输入站点名称', trigger: 'blur' }],
          station_status: [{ required: true, message: '请选择站点状态', trigger: 'change' }]
        }
      }
    }
  },
  methods: {
    timeChange(date) {
      this.searchData.create_time = date;
    },
    
    getStationStatusText(status) {
      const statusMap = {
        '0': '未知',
        '1': '建设中',
        '5': '关闭下线',
        '6': '维护中',
        '50': '正常使用'
      };
      return statusMap[status] || '未知';
    },
    getStationTypeText(type) {
      const typeMap = {
        '1': '公共',
        '50': '个人',
        '100': '公交（专用）',
        '101': '环卫（专用）',
        '102': '物流（专用）',
        '103': '出租车（专用）',
        '255': '其他'
      };
      return typeMap[type] || '未知';
    },
    
    getConstructionText(construction) {
      const constructionMap = {
        '1': '居民区',
        '2': '公共机构',
        '3': '企事业单位',
        '4': '写字楼',
        '5': '工业园区',
        '6': '交通枢纽',
        '7': '大型文体设施',
        '8': '城市绿化',
        '9': '大型建筑配建停车场',
        '10': '路边停车位',
        '11': '城际高速服务区',
        '255': '其他'
      };
      return constructionMap[construction] || '未知';
    },
    
    getParkTagText(parkTag) {
      if (parkTag === null || parkTag === undefined || parkTag === '') {
        return '无';
      }
      const parkTagMap = {
        '1': '免费停车',
        '2': '限时免费停车',
        '3': '停车收费'
      };
      return parkTagMap[String(parkTag)] || '无';
    },
    
    getSystemStatusText(status) {
      if (status === null || status === undefined || status === '') {
        return '未知';
      }
      const statusMap = {
        '0': '下线',
        '1': '在线'
      };
      return statusMap[String(status)] || (status === 1 ? '在线' : '下线');
    },
    
    showDetail(row) {
      this.detailDrawer.data = row;
      this.detailDrawer.show = true;
    },
    
    closeDetailDrawer() {
      this.detailDrawer.show = false;
      this.detailDrawer.data = null;
    },
    cancelEdit() {
      this.editModal.show = false;
      this.$refs.editForm.resetFields();
    },
    exportData(){
      // 防止重复点击
      if (this.exportLoading) {
        console.log('导出正在进行中，请稍候...');
        return;
      }

      console.log('开始执行导出，时间:', new Date().toISOString());
      this.exportLoading = true;

      this.$commonFun.postProxy('admin/xindian_station/exportStations',this.searchData).then((res)=>{
        this.exportLoading = false;
        console.log('导出请求完成，结果:', res);

        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`充电站列表.xlsx`)
        })
      }).catch(error => {
        this.exportLoading = false;
        console.error('导出请求失败:', error);
      })
    },
    syncStations() {
      this.$Modal.confirm({
        title: '确认同步',
        content: '确定要同步新电途站点数据吗？',
        onOk: () => {
          this.$commonFun.postProxy('admin/xindian_station/sync')
            .then(res => {
              this.$commonFun.dealApiResult(res, () => {
                this.$Message.success('同步成功');
                this.$refs.table.getLists();
              });
            });
        }
      });
    },
    // 更新 methods 中的相关方法
    editStation(row) {
      // 先获取完整的站点详情数据
      console.log('编辑站点，传入的行数据:', row);
      
      // 检查必要的字段是否存在
      if (!row.station_id) {
        this.$Message.error('站点ID不存在，无法编辑');
        return;
      }
      
      // 先获取完整的站点详情数据
      this.$commonFun.postProxy('admin/xindian_station/getStationDetail', { id: row.id })
          .then(res => {
            this.$commonFun.dealApiResult(res, (data) => {
              if (!data.data.station_info) {
                this.$Message.error('未获取到站点详情信息');
                return;
              }
              
              this.editDrawer.data = data.data.station_info;
              this.editDrawer.form = {
                id: data.data.station_info.id,
                station_name: data.data.station_info.station_name,
                station_status: data.data.station_info.station_status.toString(),
                status: data.data.station_info.status.toString(),
                park_tag: data.data.station_info.park_tag.toString(),
                address: data.data.station_info.address,
                electricity_fee: data.data.station_info.preferential_elec_fee,
                construction: data.data.station_info.construction.toString(),
                station_type: data.data.station_info.station_type.toString(),
                station_tel: data.data.station_info.station_tel || data.data.station_info.service_tel,
                support_order: Boolean(data.data.station_info.support_order),
                vin_flag: Boolean(data.data.station_info.vin_flag),
                hw_supper_charge: Boolean(data.data.station_info.hw_supper_charge)
              };
              
              console.log('设置的表单数据:', this.editDrawer.form);
              this.editDrawer.show = true;
            });
          })
          .catch(error => {
            console.error('获取站点详情失败:', error);
            this.$Message.error('获取站点详情失败: ' + error.message);
          });
    },

    closeEditDrawer() {
      this.editDrawer.show = false;
      this.editDrawer.data = null;
      this.$refs.editForm.resetFields();
    },

    saveStation() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editDrawer.loading = true;
          
          // 创建一个副本并确保布尔值转换为数字格式（如果API需要）
          const formData = { ...this.editDrawer.form };
          formData.support_order = formData.support_order ? 1 : 0;
          formData.vin_flag = formData.vin_flag ? 1 : 0;
          formData.hw_supper_charge = formData.hw_supper_charge ? 1 : 0;
          
          this.$commonFun.postProxy('admin/xindian_station/updateStation', formData)
              .then(res => {
                this.$commonFun.dealApiResult(res, () => {
                  this.$Message.success('保存成功');
                  this.closeEditDrawer();
                  this.$refs.table.getLists();
                });
              })
              .finally(() => {
                this.editDrawer.loading = false;
              });
        }
      });
    }
  }
}
</script>

<style scoped>
.xindian-station {
  padding: 20px;
}

.station-detail {
  padding: 20px;
}

.detail-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
}

.detail-section h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #17233d;
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 10px;
}

.detail-section p {
  margin: 8px 0;
  line-height: 1.6;
}

.lx-search-item {
  width: 200px;
}
.station-edit {
  padding: 20px;
}

.edit-actions {
  text-align: center;
  padding: 20px 0;
  border-top: 1px solid #e8eaec;
  margin-top: 20px;
}
</style>